import { useEffect, type ReactNode } from 'react'
import { Link } from 'react-router-dom'
import {
  ArrowRightIcon,
  LandingIcon,
} from '@/pages/IndexPage/sorteeLanding/components/icons'
import styles from './AuthLayout.module.css'

export function AuthLayout({
  children,
  mode,
}: {
  children: ReactNode
  mode: 'login' | 'cadastro'
}) {
  const isLogin = mode === 'login'
  useEffect(() => {
    const elements = [
      document.documentElement,
      document.body,
      document.getElementById('root'),
    ]
    elements.forEach((element) => element?.classList.add('sortee-auth-active'))
    window.scrollTo({ top: 0, behavior: 'instant' })
    return () =>
      elements.forEach((element) => element?.classList.remove('sortee-auth-active'))
  }, [mode])
  return (
    <div className={styles.page}>
      <header className={styles.header}>
        <Link to="/" aria-label="Sortee, página inicial" className={styles.logo}>
          <img src="/logo/sortee.png" width="2089" height="753" alt="Logo Sortee" />
        </Link>
        <Link to="/" className={styles.back}>
          <ArrowRightIcon /> Voltar ao início
        </Link>
      </header>
      <main className={styles.main}>
        <aside className={styles.story}>
          <p className={styles.eyebrow}>SUA IDEIA. SEU PRÓXIMO PASSO.</p>
          <h2>
            {isLogin ? 'Bom ter você' : 'Toda campanha'}
            <br />
            <em>{isLogin ? 'por aqui de novo.' : 'começa com uma ideia.'}</em>
          </h2>
          <p className={styles.description}>
            {isLogin
              ? 'Seu próximo movimento começa aqui. Acesse o painel e acompanhe cada parte da sua campanha.'
              : 'Dê forma à sua campanha, compartilhe com o público e acompanhe tudo pelo mesmo painel.'}
          </p>
          <div className={styles.orbit} aria-hidden="true">
            <div className={styles.ring} />
            <div className={styles.ringInner} />
            <div className={styles.orbitCore}>
              <LandingIcon name="page" width="46" height="46" />
            </div>
            <span className={styles.orbitLabel}>
              <LandingIcon name="check" /> Sua campanha, conectada.
            </span>
            <span className={styles.orbitDot} />
          </div>
          <div className={styles.storyFooter}>
            <LandingIcon name="dashboard" />
            <p>
              Da criação aos resultados.
              <br />
              <strong>Tudo sob seu controle.</strong>
            </p>
          </div>
        </aside>
        <section
          className={styles.formPanel}
          aria-label={isLogin ? 'Acesso à conta' : 'Cadastro de conta'}
        >
          <div className={styles.card}>{children}</div>
        </section>
      </main>
      <footer className={styles.footer}>
        <span>Sortee · Sua marca. Sua campanha.</span>
        <nav aria-label="Documentos legais">
          <a
            href="https://sorteios.com.br/termos-de-uso/"
            target="_blank"
            rel="noopener noreferrer"
          >
            Termos de Uso
          </a>
          <a
            href="https://sorteios.com.br/politica-de-privacidade/"
            target="_blank"
            rel="noopener noreferrer"
          >
            Privacidade
          </a>
        </nav>
      </footer>
    </div>
  )
}
